module.exports = __webpack_public_path__ + "static/media/integrations-icon.85f0d0f7.svg";